<template>
	<span>
		<template v-if="formattedPriceParts.currencyBefore">{{ formattedPriceParts.symbol }}{{ formattedPriceParts.space }}</template>
		<span :data-testid="getTestID">{{ formattedPriceParts.price }}</span>
		<template v-if="!formattedPriceParts.currencyBefore">{{ formattedPriceParts.space }}{{ formattedPriceParts.symbol }}</template>
	</span>
</template>

<script>
export default {
	props: {
		price: Number,
		dataTestID: String,
	},
	computed: {
		i18n() { return this.$i18n; },
		settings() { return this.$kpsSettings; },
		canFormat() {
			return !! this.price && ! isNaN( this.price );
		},
		getTestID() {
			return this.dataTestID ? this.dataTestID : false;
		},
		renderedPrice() {
			if ( ! this.canFormat ) {
				return '';
			}

			const numberFormatter = new Intl.NumberFormat( this.settings.shop.locale.replace( '_', '-' ), {
				style: 'currency',
				currency: this.settings.shop.currency,
			} );

			return numberFormatter.format( this.price );
		},
		formattedPriceParts() {
			if (!this.canFormat) {
				return ['', ''];
			}

			const numberFormatter = new Intl.NumberFormat(this.settings.shop.locale.replace('_', '-'), {
				style: 'currency',
				currency: this.settings.shop.currency,
			});

			// Format the price
			const formattedPrice = numberFormatter.format(this.price);

			// Extract the currency and number
			const currencySymbol = new Intl.NumberFormat(this.settings.shop.locale.replace('_', '-'), {
				style: 'currency',
				currency: this.settings.shop.currency,
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
			}).formatToParts(0).find(part => part.type === 'currency').value;

			// Check if the currency is before or after the number
			const isCurrencyBefore = formattedPrice.startsWith(currencySymbol);

			// Check if there's a space or non-breaking space between the currency and the number
			const hasSpace = /\s/.test(formattedPrice) || formattedPrice.indexOf('\u00A0') >= 0;

			// Split the formatted price into parts
			const numberPart = formattedPrice.replace(currencySymbol, '').trim();

			return {
				'symbol': currencySymbol,
				'price': numberPart,
				'currencyBefore': isCurrencyBefore,
				'space': hasSpace ? ' ' : '',
			};
		},
	},
};
</script>
